var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckAllBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Interface / Check_All_Big"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.33332 16L15.933 22.5996L30.0763 8.45764M2.73306 16.067L9.33273 22.6667M23.4747 8.5247L16.4036 15.5958",
    stroke: "#B79843",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckAllBig);
export default __webpack_public_path__ + "static/media/Check_All_Big.51cbcc4b86a98d2eeeeb0a4b64a7ece5.svg";
export { ForwardRef as ReactComponent };